import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';
import { semVerSchema } from '@zaoblako/shared/modules/serde/schemas/sem-ver.schema';

/** 1C ERP plugin single APis URL parameters - DTO signature */
export interface Plugin1cParamsInterface {
  /** Plugin version in "SemVer" format */
  version: string;
}

/** 1C ERP plugin single APis URL parameters - DTO schema */
export const Plugin1cParamsDto = SerdeDtoClass.create<Plugin1cParamsInterface>(IntergrationDtoKeyEnum.PLUGIN_1C_PARAMS_DTO, {
  version: {
    label: 'Версия',
    serializer: semVerSchema,
  },
});
